// import React, { useState, useEffect, useMemo } from 'react';
// import { ThemeProvider, CssBaseline, Box, createTheme } from '@mui/material';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// import Login from './components/Login';
// import Register from './components/Register';
// import LandingPage from './components/LandingPage';
// import TaskBar from './components/TaskBar';
// import Chat from './components/Chat';
// import PrivateChat from './components/PrivateChat';
// import PrivateChatSelection from './components/PrivateChatSelection';
// import Profile from './components/Profile';
// import Settings from './components/Settings';
// import HomePage from './components/HomePage';
// import RequestReset from "./components/RequestReset";
// import ResetPassword from "./components/ResetPassword";
// import GroupChatPage from './components/GroupChatPage';

// import socket from './socket';

// function App() {
//   const [user, setUser] = useState(() => {
//     const stored = localStorage.getItem('user');
//     return stored ? JSON.parse(stored) : null;
//   });

//   const [showRegister, setShowRegister] = useState(!user);
//   const [showLanding, setShowLanding] = useState(!user);
//   const [onlineUsers, setOnlineUsers] = useState([]);

//   const [darkMode, setDarkMode] = useState(() => {
//     const saved = localStorage.getItem('darkMode');
//     return saved ? JSON.parse(saved) : true;
//   });

//   const theme = useMemo(() =>
//     createTheme({
//       palette: {
//         mode: darkMode ? 'dark' : 'light',
//         primary: { main: '#7b5cf5' },
//         secondary: { main: '#9562e2' },
//       }
//     }),
//     [darkMode]
//   );

//   useEffect(() => {
//     if (user) {
//       socket.emit('requestOnlineUsers');
//     }
//     socket.on('onlineUsers', (users) => {
//       setOnlineUsers(users);
//     });
//     return () => {
//       socket.off('onlineUsers');
//     };
//   }, [user]);

//   const handleUserAuth = (userData) => {
//     setUser(userData);
//     localStorage.setItem('user', JSON.stringify(userData));
//     setShowLanding(false);
//     setShowRegister(false);
//   };

//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem('user');
//     setShowLanding(true);
//   };

//   const handleLandingLoginClick = () => {
//     setShowLanding(false);
//     setShowRegister(false);
//   };

//   const handleLandingRegisterClick = () => {
//     setShowLanding(false);
//     setShowRegister(true);
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <BrowserRouter>
//         {!user ? (
//           <Routes>
//             <Route path="/" element={
//               showLanding ? (
//                 <LandingPage 
//                   onLoginClick={handleLandingLoginClick} 
//                   onRegisterClick={handleLandingRegisterClick} 
//                 />
//               ) : showRegister ? (
//                 <Register 
//                   onRegister={handleUserAuth} 
//                   onSwitchToLogin={() => setShowRegister(false)} 
//                 />
//               ) : (
//                 <Login 
//                   onLogin={handleUserAuth} 
//                   onSwitchToRegister={() => setShowRegister(true)} 
//                 />
//               )
//             } />
//             <Route path="/forgot-password" element={<RequestReset />} />
//             <Route path="/reset-password" element={<ResetPassword />} />
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Routes>
//         ) : (
//           <>
//             <TaskBar
//               username={user.username}
//               profilePhoto={user.profilePhoto}
//               onLogout={handleLogout}
//             />
//             <Box sx={{ pt: '64px' }}>
//               <Routes>
//                 <Route path="/" element={
//                   <HomePage user={user} setUser={setUser} onlineUsers={onlineUsers} />
//                 } />
//                 <Route path="/group" element={<Chat userId={user.id} username={user.username} />} />
//                 <Route path="/private/select" element={<PrivateChatSelection userId={user.id} onlineUsers={onlineUsers} />} />
//                 <Route path="/private/:userId" element={<PrivateChat userId={user.id} username={user.username} socket={socket} />} />
//                 <Route path="/profile" element={<Profile userId={user.id} username={user.username} />} />
//                 <Route path="/settings" element={<Settings darkMode={darkMode} setDarkMode={setDarkMode} />} />
//                 <Route path="/groups" element={<GroupChatPage currentUserId={user.id || user._id} />} />
//                 <Route path="*" element={<Navigate to="/group" replace />} />
//               </Routes>
//             </Box>
//           </>
//         )}
//       </BrowserRouter>
//     </ThemeProvider>
//   );
// }

// export default App;



import React, { useState, useEffect, useMemo } from 'react';
import { ThemeProvider, CssBaseline, Box, createTheme } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './components/Login';
import Register from './components/Register';
import LandingPage from './components/LandingPage';
import TaskBar from './components/TaskBar';
import Chat from './components/Chat';
import PrivateChat from './components/PrivateChat';
import PrivateChatSelection from './components/PrivateChatSelection';
import Profile from './components/Profile';
import Settings from './components/Settings';
import HomePage from './components/HomePage';
import RequestReset from "./components/RequestReset";
import ResetPassword from "./components/ResetPassword";
import GroupChatPage from './components/GroupChatPage';
import NotificationSystem from './components/NotificationSystem';

import socket from './socket';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

function App() {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const [showRegister, setShowRegister] = useState(false);
  const [showLanding, setShowLanding] = useState(!user);
  const [onlineUsers, setOnlineUsers] = useState([]);

  const [darkMode] = useState(true);

  const theme = useMemo(() =>
    createTheme({
      palette: {
        mode: 'dark',
        primary: { main: '#00C2B3' },
        secondary: { main: '#00A89A' },
        background: { default: '#090C0F', paper: '#0E1318' },
      },
      typography: {
        fontFamily: "'Outfit', sans-serif",
      },
    }),
    []
  );

  // Fetch fresh user data on mount to get profilePhoto
  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('token');
    const uid = user._id || user.id;
    if (!uid || !token) return;
    axios.get(`${API_BASE}/api/users/${uid}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        const merged = { ...user, ...res.data };
        setUser(merged);
        localStorage.setItem('user', JSON.stringify(merged));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!user) return;
    socket.on('onlineUsers', (users) => {
      setOnlineUsers(users);
    });
    socket.emit('requestOnlineUsers');
    return () => { socket.off('onlineUsers'); };
  }, [user]);

  const handleUserAuth = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    setShowLanding(false);
    setShowRegister(false);
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setShowLanding(true);
  };

  const updateUser = (newData) => {
    const merged = { ...user, ...newData };
    setUser(merged);
    localStorage.setItem('user', JSON.stringify(merged));
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        {!user ? (
          <Routes>
            <Route path="/" element={
              showLanding ? (
                <LandingPage
                  onLoginClick={() => { setShowLanding(false); setShowRegister(false); }}
                  onRegisterClick={() => { setShowLanding(false); setShowRegister(true); }}
                />
              ) : showRegister ? (
                <Register onRegister={handleUserAuth} onSwitchToLogin={() => setShowRegister(false)} />
              ) : (
                <Login onLogin={handleUserAuth} onSwitchToRegister={() => setShowRegister(true)} />
              )
            } />
            <Route path="/forgot-password" element={<RequestReset />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <>
            <TaskBar
              username={user.username}
              profilePhoto={user.profilePhoto}
              onLogout={handleLogout}
            />
            <NotificationSystem />
            <Box>
              <Routes>
                <Route path="/" element={
                  <HomePage user={user} setUser={updateUser} onlineUsers={onlineUsers} />
                } />
                <Route path="/group" element={
                  <Chat userId={user._id || user.id} username={user.username} />
                } />
                <Route path="/private/select" element={
                  <PrivateChatSelection userId={user._id || user.id} onlineUsers={onlineUsers} />
                } />
                <Route path="/private/:userId" element={
                  <PrivateChat
                    userId={user._id || user.id}
                    username={user.username}
                    socket={socket}
                  />
                } />
                <Route path="/profile" element={
                  <Profile userId={user._id || user.id} username={user.username} />
                } />
                <Route path="/settings" element={<Settings />} />
                <Route path="/groups" element={
                  <GroupChatPage
                    currentUserId={user._id || user.id}
                    currentUsername={user.username}
                    currentUserPhoto={user.profilePhoto}
                  />
                } />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Box>
          </>
        )}
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;